import { BulkLineItem } from "../../../model/bulk-purchase/bulk-purchase-customer";

export type BulkViewState = "entry" | "confirmation" | "pin" | "processing" | "success" | "failed";

export const BULK_VIEW_FLOW: Record<BulkViewState, { prev?: BulkViewState; next?: BulkViewState }> = {
	entry: { next: "confirmation" },
	confirmation: { prev: "entry", next: "pin" },
	pin: { prev: "confirmation", next: "processing" },
	processing: { prev: "confirmation", next: undefined },
	success: { prev: undefined, next: undefined },
	failed: { prev: undefined, next: undefined },
};

export type BulkTab = "manual" | "upload";

export type BulkPaymentMethod = "wallet" | "card";

/** Quick-select amount chips shown on the manual entry form (per Figma). */
export const BULK_AMOUNT_PRESETS = [5000, 10000, 20000, 50000, 100000, 200000];

export interface BulkTotals {
	total: number;
	prepaidCount: number;
	postpaidCount: number;
}

export function computeTotals(items: BulkLineItem[]): BulkTotals {
	return {
		total: items.reduce((sum, i) => sum + (i.amount || 0), 0),
		prepaidCount: items.filter(i => i.serviceType === "Prepaid").length,
		postpaidCount: items.filter(i => i.serviceType === "Postpaid").length,
	};
}
